import { useEffect } from 'react';
import { BackgroundNotification } from '@erecruit/modules';
import { Intl } from '@erecruit/core';
import { notificationActions } from './state/reducer';
import { createNotification } from './helpers';
import { FirebaseMessage } from '../../App/types';

export function useNotifications(
  push: typeof notificationActions['push'],
  getUnreadCount: typeof notificationActions['getUnreadCount'],
  intl: Intl.InjectedIntl,
) {
  useEffect(() => {
    const pushNotification = (event: MessageEvent) => {
      let notification: FirebaseMessage;
      if ('firebaseMessaging' in event.data) {
        notification = event.data.firebaseMessaging.payload;
      } else {
        notification = event.data;
      }

      const formattedNotification: BackgroundNotification = {
        from: notification.from,
        data: {
          id: notification.data.id,
          data: notification.data,
          title: notification.notification.title,
          body: notification.notification.body,
        },
      };
      push([createNotification(formattedNotification, intl)]);
      getUnreadCount();
    };

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', pushNotification);
    }

    return () => {
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.removeEventListener(
          'message',
          pushNotification,
        );
      }
    };
  }, [push, getUnreadCount, intl]);
}
